export const MUSTARD = '#FFDB5A'
export const BLOND = '#FFF3B5'
export const POLISHED_PINE = '#4DA896'
export const MIDNIGHT_GREEN = '#0E3B43'
export const GAINSBORO = '#D9D9D9'